import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__WidgetJobs extends ScrollItem__BlockDefault {
    _holder;
    _url;
    _jobs = [];

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._holder = GetBy.class('__jobs', this.item)[0];
        this._url = this.item.getAttribute('data-works-url') || '';
        this._jobs = this._readEmbedded();
        this._refresh();
    }

    // Same shape as src/_data/works.js
    static formatMeta(__job) {
        const loc = Array.isArray(__job.locations) ? __job.locations[0] : null;
        const city = __job.city || loc?.city || '';
        const country = __job.country || loc?.country || '';
        const codeRaw = loc?.countryCode || '';
        const code = codeRaw === 'GB' ? 'UK' : codeRaw;

        let place = '';
        if (city && code) place = `${city} (${code})`;
        else if (city) place = city;
        else place = country;

        const contract = String(__job.employment_type || '').replace(/-/g, ' ');
        const mode = __job.telecommuting || !city ? 'Remote' : 'Hybrid';

        return [place, contract, mode].filter(Boolean).join(' / ');
    }

    static normalize(__data) {
        const list = Array.isArray(__data?.jobs) ? __data.jobs : [];
        const jobs = list.map((job) => ({
            id: job.shortcode || '',
            type: job.department || 'Other',
            name: job.title || '',
            location: ScrollItem__WidgetJobs.formatMeta(job),
            url: job.url || job.shortlink || '',
        }));

        jobs.sort((a, b) => a.type.localeCompare(b.type) || a.name.localeCompare(b.name));
        return jobs;
    }

    static fingerprint(__jobs) {
        return (__jobs || []).map((j) => j.id || `${j.name}|${j.url}`).join('|');
    }

    _readEmbedded() {
        const script = GetBy.class('__works-data', this.item)[0];
        if (!script) return [];
        try {
            return JSON.parse(script.textContent) || [];
        } catch {
            return [];
        }
    }

    async _refresh() {
        if (!this._url || !this._holder) return;

        try {
            const res = await fetch(this._url);
            if (!res.ok) return;

            const jobs = ScrollItem__WidgetJobs.normalize(await res.json());
            if (ScrollItem__WidgetJobs.fingerprint(jobs) === ScrollItem__WidgetJobs.fingerprint(this._jobs)) {
                return;
            }

            this._jobs = jobs;
            this._render(jobs);
            this._writeEmbedded(jobs);
        } catch {
            // Keep build-time list
        }
    }

    _writeEmbedded(__jobs) {
        const script = GetBy.class('__works-data', this.item)[0];
        if (script) script.textContent = JSON.stringify(__jobs);
    }

    _render(__jobs) {
        let html = '';
        let prevType = null;

        for (let i = 0; i < __jobs.length; i++) {
            const item = __jobs[i];
            const isFirstOfType = item.type !== prevType;

            if (isFirstOfType) {
                if (prevType !== null) html += '</ul>';
                html += `<div class="ul-title --crema">${item.type}</div><ul>`;
                prevType = item.type;
            }

            html += `
                <li>
                    <a class="card-job --crema" href="${item.url}" target="_blank" rel="noopener">
                        ${isFirstOfType ? '<span class="line --first --crema"></span>' : ''}
                        <div class="holder">
                            <span class="arrow --first" aria-hidden="true">→</span>
                            <span class="name">${item.name}</span>
                            <span class="location">${item.location}</span>
                            <span class="arrow --last" aria-hidden="true">→</span>
                        </div>
                        <span class="line --crema"></span>
                    </a>
                </li>
            `;
        }

        if (prevType !== null) html += '</ul>';
        this._holder.innerHTML = html;
    }
}

Scroll._registerClass('WidgetJobs', ScrollItem__WidgetJobs);

export default ScrollItem__WidgetJobs;
